@switch (ek?.yz) {
@default {
<div class="komut-liste">
    <button nz-button
            nzGhost
            nzBlock
            class="mb-2"
            (click)="ek.yz='YazıdanResme';CD.detectChanges();">Yazı'dan
        Resim'e</button>
    <button nz-button
            nzGhost
            nzBlock
            class="mb-2">Resim'den Yazı'ya</button>
    <button nz-button
            nzGhost
            nzBlock
            class="mb-2">Yüz Değiştir</button>
    <button nz-button
            nzGhost
            nzBlock
            class="mb-2">Yapay Sohbet</button>
</div>
}
@case ("YazıdanResme") {
<fiko-yazidan-resme [(ek)]="ek"></fiko-yazidan-resme>
}

}